export { Head as default } from './Head'
